module.exports = __webpack_public_path__ + "img/nineEmpty.a70079b4.png";